import React from 'react';

import { ADD_COURSE_CONTEXT_ITEMS } from 'constants/common';

import { getTranslation } from 'helpers/getTranslation';

import { getArcades } from 'store/arcades/actions';

import { Loading } from 'components/shared/Loading';
import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';
import { Switch } from 'components/shared/Switch';
import { Typography } from 'components/shared/Typography';

import { MenuLayout } from 'components/Layout';
import { EmptyState } from 'components/EmptyState';
import { ListToolbar } from 'components/Toolbar';
import { ArcadesTable } from 'components/ArcadesTable';
import { CreateButton } from 'components/CreateButton';

import styles from './ArcadesPage.module.scss';

const ArcadesPage = ({
  locale,
  loading,
  isRootAdmin,
  arcades,
  sortParams,
  columns,
  onSearchChange,
  onSortChange,
  onContextItemClick,
  onArcadeRowClick,
  onCreateArcadeClick,
  onArcadeRemoveClick,
  onArcadeEditClick,
  showArchived,
  onShowArchivedChange,
  listQueryParams,
}: {
  locale: any;
  loading: any;
  isRootAdmin: any;
  arcades: any;
  sortParams: any;
  columns: any;
  onSearchChange: any;
  onSortChange: any;
  onContextItemClick: any;
  onArcadeRowClick: any;
  onCreateArcadeClick: any;
  onArcadeRemoveClick: any;
  onArcadeEditClick: any;
  showArchived: any;
  onShowArchivedChange: any;
  listQueryParams: any;
}) => {
  return (
    <MenuLayout>
      <ListToolbar
        title={getTranslation('arcades_page.title')}
        actionComponent={
          <div className={styles.toolbarActions}>
            <div className={styles.archivedFilter}>
              <Typography className={styles.archivedLabel} variant="body2">
                {getTranslation('courses_page.show_archived')}
              </Typography>
              <Switch
                size="sm"
                checked={showArchived}
                onChange={onShowArchivedChange}
              />
            </div>
            {isRootAdmin ? (
              <Button
                size="md"
                variant="link"
                startIcon={<Icon name="plusRound" />}
                onClick={onCreateArcadeClick}
              >
                {getTranslation('arcades_page.create_arcade_button')}
              </Button>
            ) : (
              <CreateButton
                buttonText={getTranslation('arcades_page.create_arcade_button')}
                contextItems={ADD_COURSE_CONTEXT_ITEMS}
                onContextItemClick={onContextItemClick}
              />
            )}
          </div>
        }
      />
      {loading ? (
        <Loading />
      ) : (
        <>
          {arcades.length ? (
            <div className={styles.inner}>
              <ArcadesTable
                locale={locale}
                params={sortParams}
                listQueryParams={listQueryParams}
                data={arcades}
                columns={columns}
                dataAction={getArcades}
                onSearchChange={onSearchChange}
                onSortChange={onSortChange}
                onRowClick={onArcadeRowClick}
                onRemoveClick={onArcadeRemoveClick}
                onEditClick={onArcadeEditClick}
              />
            </div>
          ) : (
            <EmptyState
              className={styles.emptyState}
              icon="arcades"
              title={getTranslation('arcades_page.empty_state.title')}
              text={getTranslation('arcades_page.empty_state.text')}
            />
          )}
        </>
      )}
    </MenuLayout>
  );
};

export default React.memo(ArcadesPage) as any;
